import { FaTwitter, FaFacebookF, FaYoutube, FaEnvelope, FaGlobe  } from "react-icons/fa"
import "./style/ClientFooter.scss"
import logo from "../../assets/images/logoNeohTrade.png"

const ClientFooter = () => {
  return (
    <footer className="client-footer">
      <div className="footer-left">
         <img src={logo} className="logoFooter" />
        <p className="tagline">Redefining The Level of Trust in Digital Finance</p>
        <div className="social-icons">
          <FaGlobe /> 25 Lime Tree bay Avenue, George Town Cayman Island
        </div>
        <p className="contact">support@neohtrade.com</p>
        <p className="copyright">© 2020–{new Date().getFullYear()} NEOH Trade All rights reserved</p>
      </div>

      <div className="footer-links">
        <div className="link-group">
          <h4>About</h4>
          <ul>
            <li><a href="/about-us">About Us</a></li>
            <li><a href="/legal-and-privacy">Legal and Privacy</a></li>
            <li><a href="/disclaimer">Disclaimer</a></li>
            <li><a href="/terms-of-use">Terms of Use</a></li>
          </ul>
        </div>
        <div className="link-group">
          <h4>Support</h4>
          <ul>
            <li><a href="/college">College</a></li>
            <li><a href="/announcement-center">Announcement Center</a></li>
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default ClientFooter
